import { render } from "./fee.vue?vue&type=template&id=0b2fbbde&scoped=true"
import script from "./fee.vue?vue&type=script&lang=js"
export * from "./fee.vue?vue&type=script&lang=js"

import "./fee.vue?vue&type=style&index=0&id=0b2fbbde&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2fbbde"]])

export default __exports__